import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { msg: String, confirm: String }

  connect() {
    // Bind the function once so it can be removed later
    this.handleClickBound = this.handleClick.bind(this)
    this.handleSubmitBound = this.handleSubmit.bind(this)

    if (this.element.tagName.toLowerCase() === "form") {
      console.log("Binding to Form")
      this.element.addEventListener("submit", this.handleSubmitBound)
    } else {
      this.element.addEventListener("click", this.handleClickBound)
    }
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClickBound)
  }

  async handleClick(event) {
    // Prevent the default action (Turbo interception) initially
    event.preventDefault()

    if (this.confirmValue){
      const confirmed = await this.customConfirm()
      if (!confirmed) return
    }

    this.showOverlay()

    // Now remove our custom event listener so Turbo can handle the click
    this.element.removeEventListener("click", this.handleClickBound)
    this.element.click()
  }

  async handleSubmit(event) {
    this.showOverlay()
  }

  customConfirm() {
    return Promise.resolve(window.confirm(this.confirmValue || "Are you sure?"))
  }

  showOverlay() {
    if (this.overlay) return

    const overlay = document.createElement("div")
    overlay.className = "w-full h-full fixed top-0 left-0 z-40 flex items-center justify-center bg-black/70"

    const container = document.createElement("div")

    const messageSpan = document.createElement("span")
    messageSpan.className = "font-bold text-white"
    messageSpan.textContent = this.msgValue || "Please wait..."

    const spinner = document.createElement("div")
    spinner.className = "inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-white border-e-transparent ml-2"

    container.appendChild(messageSpan)
    container.appendChild(spinner)
    overlay.appendChild(container)

    document.body.appendChild(overlay)
    this.overlay = overlay
  }
}
